"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  loadBefore: 'load origin',
  loadStart: 'loading',
  loadEnd: 'loading completed'
};
exports.default = _default;